import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { WizardComponent } from "ngx-wizard";
import { Order } from "../../../../../objects/orders/order";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { NgForm } from "@angular/forms";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { PageVisit } from "../../../../../objects/pages/pageVisit";

@Component({
    selector: "email-tabs-v2",
    templateUrl: "./email-tab-v2.component.html",
    moduleId: module.id.toString()
})
export class EmailTabsV2Component {

    @Input()
    public wizardComponent: WizardComponent;

    @Input()
    public order: Order;
    @Input()
    public wizardFooterTemplate:  TemplateRef<any>;

    @Output()
    public isNeedSendEmail: EventEmitter<boolean> = new EventEmitter<boolean>();

    public isEmailCopy?: boolean = null;
    public currentEmail?: string = null;
    public currentPhone?: string = null;
    public currentName?: string = null;
    public isEmailShow: boolean = false;
    public calculatorHelper = CalculatorHelper;
    public communicationSwitcher: boolean = true;
    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();
    @ViewChild("emailForm") emailFormRef: NgForm;

    constructor(
        private detectChanges: ChangeDetectorRef, 
        public googleTagService: GoogleTagService) {}

    public toggleSwitcher(){
        this.communicationSwitcher = !this.communicationSwitcher;
    }

    public showEmailTab(event: any): void {
        event.preventDefault();

        this.isEmailShow = this.isEmailCopy;

        setTimeout(_ => this.wizardComponent.nextTab(false), 100);
    }

    public setEmailToCustomer(): void {
        this.order.Customer.Email = this.currentEmail;
    }

    public setPhoneToCustomer(): void {
        this.order.Customer.Phone = this.currentPhone;
        this.order.Customer.FirstName = this.currentName;
    }

    public hnadleDisableContinueButton() {
        setTimeout(_ => {
            if(!this.currentEmail || !this.emailFormRef.valid)
                this.wizardComponent.activeTab.isNextButtonDisabled = true;
            else
                this.wizardComponent.activeTab.isNextButtonDisabled = false;
        }, 25);
    }

    public getEmailCopy(value: boolean, isEmailCopy: boolean): void{
        this.isEmailCopy = this.calculatorHelper.getButtonValue(value, isEmailCopy);
        this.isNeedSendEmail.emit(this.isEmailCopy);
        this.detectChanges.detectChanges();
    }
}


// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/email-tab/email-tab-v2.component.ts